define('SC.BackInStockNotification.1.0.0.BackInStockNotification', [
    'BackInStock.View',
    'BackInStockNotification.Helper',
    'jQuery',
    'Utils'
], function BackInStockNotification(
    BackInStockView,
    BackInStockNotificationHelper,
    jQuery
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var pdp = application.getComponent('PDP');
            var layout = application.getComponent('Layout');

            layout.on('afterShowContent', function beforeShowContent() {
                BackInStockNotificationHelper.addToNavigtion();
                jQuery(window).on('resize', BackInStockNotificationHelper.addToNavigtion);
            });

            pdp.addChildViews(
                pdp.PDP_FULL_VIEW, {
                    'SocialSharing.Flyout': {
                        'BackInStock.View': {
                            childViewIndex: 1,
                            childViewConstructor: function childViewConstructor() {
                                if (!pdp.getItemInfo().item.keyMapping_showGrid) {  // eslint-disable-line consistent-return
                                    return new BackInStockView({
                                        pdp: pdp,
                                        application: application
                                    });
                                }
                            }
                        }
                    }
                }
            );
        }
    };
});
